import React, { useEffect, useState } from 'react';
import Avtar from './Avtar';
import { Row, Col, Card, CardBody, CardHeader, Button, Modal, ModalBody, ModalHeader, Badge } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../../style/color';
import axios from 'axios';
import { mainurl } from '../../../Mainurl';
import { FaEye, FaFilePdf, FaUser, FaPhone, FaMapMarkerAlt, FaSeedling, FaUniversity, FaTint, FaIdCardAlt } from 'react-icons/fa';
import { LuLandPlot } from 'react-icons/lu';
import { BiDownload } from 'react-icons/bi';
import { BsBank2 } from "react-icons/bs";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { type } from '@testing-library/user-event/dist/type';

const ViewFarmer = ({ data, back }) => {
    const [loading, setLoading] = useState(false);
    const [gender, setGender] = useState('');
    const [category, setCategory] = useState('');
    const [cropPatternData, setCropPatternData] = useState([]);
    const [loanData, setLoanData] = useState([]);
    const [loanDetailData, setLoanDetailData] = useState([]);
    const [documentDetals, setDocumentDetals] = useState([]);
    const [landDetals, setLandDetals] = useState([]);
    const [bankDetals, setBankDetals] = useState([]);
    const [viewModal, setViewModal] = useState(false);
    const [pdfGenerating, setPdfGenerating] = useState(false);

    // Enhanced table styles with modern design
    const enhancedTableStyles = {
        ...custTableStyles,
        headRow: {
            style: {
                backgroundColor: '#f8f9fa',
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px',
                minHeight: '48px',
                fontWeight: '600',
                fontSize: '14px',
                color: '#495057',
            },
        },
        rows: {
            style: {
                minHeight: '56px',
                fontSize: '14px',
                '&:hover': {
                    backgroundColor: '#f8f9fa',
                    cursor: 'pointer',
                },
                borderBottom: '1px solid #e9ecef',
            },
        },
        cells: {
            style: {
                paddingLeft: '16px',
                paddingRight: '16px',
            },
        },
    };

    useEffect(() => {
        if (data.gender === '1') {
            setGender('Male');
        } else {
            setGender('Female');
        }
        if (data.category === '1') {
            setCategory('General');
        } else if (data.category === '2') {
            setCategory('OBC');
        } else if (data.category === '3') {
            setCategory('ST');
        } else if (data.category === '4') {
            setCategory('SC');
        }

        setCropPatternData([
            { ids: 1, fy: '2024-2025', season: 'Rabi', crop_name: 'Cowpea', area: 2.5, harvesting: 500 },
            { ids: 2, fy: '2024-2025', season: 'Garma', crop_name: 'Bitter Gourd', area: 1.0, harvesting: 300 },
            { ids: 3, fy: '2024-2025', season: 'Kharif', crop_name: 'Chilli', area: 1.5, harvesting: 400 },
            { ids: 4, fy: '2024-2026', season: 'Rabi', crop_name: 'Tomato', area: 2.0, harvesting: 600 },
        ]);

        get_loan_list();
        get_land_dtl();
        get_document_dtl();
        get_bank_dtl();
    }, []);

    const get_bank_dtl = () => {
        setLoading(true);
        let postData = [{ "org_id": sessionStorage.getItem('org_id'), "user_id": sessionStorage.getItem('user_id'), "farmer_code": data.farmer_code }];

        axios({
            method: 'post',
            url: mainurl + 'Farmer/view_farmer_bank',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return {
                        ids: index + 1,
                        bank_id: row.bank_name,
                        ifsc_code: row.ifsc_code,
                        ac_no: <Badge color="info" pill>{row.ac_no}</Badge>,
                        ac_type: row.ac_type,
                        branch_name: row.branch_name,
                        balance: <span className={row.balance_type === '1' ? "fw-bold text-success" : "fw-bold text-danger"}>₹{Number(row.balance).toLocaleString()}</span>,
                        balance_type: row.balance_type === '1' ? <Badge color="success" pill> Credit </Badge> : <Badge color="danger" pill> Debit </Badge>,
                    }
                });
                setBankDetals(list);
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            });
    }
    const get_loan_list = () => {
        setLoading(true);
        let postData = [{ "org_id": sessionStorage.getItem('org_id'), "user_id": sessionStorage.getItem('user_id'), "farmer_id": data.farmer_code }];

        axios({
            method: 'post',
            url: mainurl + 'Farmer/farmer_loan_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return {
                        ids: index + 1,
                        bank: row.bank_id,
                        loan_ac_no: row.loan_ac_no,
                        loan_type: <Badge color="info" pill>{row.loan_type}</Badge>,
                        loan_amount: <span className="fw-bold text-success">₹{Number(row.loan_amount).toLocaleString()}</span>,
                        loan_disbursement_date: row.loan_disbursement_date,
                        loan_payment_amount: <div className="d-flex align-items-center justify-content-between">
                            <span className="fw-bold">₹{Number(row.loan_payment_amount).toLocaleString()}</span>
                            <Button
                                size="sm"
                                color="warning"
                                outline
                                className="ms-2 rounded-pill"
                                onClick={() => loan_detail_handler(row)}
                            >
                                <FaEye size={14} />
                            </Button>
                        </div>,
                        loan_outstanding: <span className="fw-bold text-danger">₹{Number(row.loan_outstanding).toLocaleString()}</span>,
                        loan_status: <Badge color={row.loan_status === 'Active' ? 'success' : 'secondary'} pill>
                            {row.loan_status}
                        </Badge>,
                    }
                });
                setLoanData(list);
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const loan_detail_handler = (data) => {
        let postData = [{ "org_id": sessionStorage.getItem('org_id'), "user_id": sessionStorage.getItem('user_id'), "loan_no": data.loan_ac_no }];

        axios({
            method: 'post',
            url: mainurl + 'Farmer/farmer_loan_details',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return {
                        ids: index + 1,
                        pay_date: row.payment_date.split(" ")[0].split('-').reverse().join('-'),
                        pay_amount: <span className="fw-bold text-success">₹{Number(row.payment_amount).toLocaleString()}</span>,
                        ref_no: row.ref_no,
                    }
                });
                setLoanDetailData(list);
                setViewModal(true);
            })
            .catch(error => {
                // Handle error
            });
    }

    // Enhanced PDF Export Handler
    const exportToPDF = async () => {
        setPdfGenerating(true);

        try {
            const element = document.getElementById('farmer-details-container');

            if (!element) {
                console.error('Container element not found');
                return;
            }

            const buttons = document.querySelector('.action-buttons');
            if (buttons) buttons.style.display = 'none';

            const canvas = await html2canvas(element, {
                scale: 2,
                useCORS: true,
                allowTaint: true,
                backgroundColor: '#ffffff',
                logging: false,
                removeContainer: true,
                ignoreElements: (element) => {
                    return element.classList.contains('cursor') ||
                        element.tagName === 'BUTTON';
                }
            });

            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4'
            });

            const imgWidth = 210;
            const pageHeight = 297;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            let heightLeft = imgHeight;
            let position = 0;

            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;

            while (heightLeft >= 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
            }

            pdf.save(`farmer-${data.farmer_code}-details.pdf`);

        } catch (error) {
            console.error('Error generating PDF:', error);
            alert('Error generating PDF. Please try again.');
        } finally {
            const buttons = document.querySelector('.action-buttons');
            if (buttons) buttons.style.display = 'block';
            setPdfGenerating(false);
        }
    };

    const InfoCard = ({ icon, label, value, color = "primary" }) => (
        <Col md={3} className="mb-3">
            <div className={`border-start border-${color} border-4 ps-3 py-2 bg-light rounded-end`}>
                <div className="d-flex align-items-center mb-1">
                    {icon && <span className={`text-${color} me-2`}>{icon}</span>}
                    <small className="text-muted fw-semibold">{label}</small>
                </div>
                <h6 className="mb-0 text-dark fw-bold">{value}</h6>
            </div>
        </Col>
    );

    const IrrigationCard = ({ src, title, isActive = false }) => (
        <Col className="text-center mb-3">
            <div className={`p-3 rounded-lg border ${isActive ? 'border-success bg-light-success' : 'border-light'} transition-all hover-shadow`}>
                <img
                    src={src}
                    alt={title}
                    className="mb-2"
                    style={{
                        width: '48px',
                        height: '48px',
                        filter: isActive ? 'brightness(1.1)' : 'grayscale(0.3)'
                    }}
                />
                <div className={`fw-semibold ${isActive ? 'text-success' : 'text-muted'}`}>
                    {title}
                </div>
                {isActive && <Badge color="success" className="mt-1">Active</Badge>}
            </div>
        </Col>
    );

    // Fetch land details

    const get_land_dtl = () => {
        let postData = [{ "org_id": Number(sessionStorage.getItem('org_id')), "user_id": Number(sessionStorage.getItem('user_id')), "farmer_code": Number(data.farmer_code) }];
        axios({
            method: 'post',
            url: mainurl + 'Farmer/view_farmer_land',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                if (!response.data || response.data.length === 0) {

                } else {

                    // Initialize editable land data
                    const landDetail = response.data.map((land, index) => {
                        let type = "-";
                        if (land.holding_type_id == "1") {
                            type = "Don";
                        } else if (land.holding_type_id == "2") {
                            type = "Baid";
                        } else if (land.holding_type_id == "3") {
                            type = "Tanr";
                        } else if (land.holding_type_id == "4") {
                            type = "Kanali";
                        }
                        let ownership = "-";
                        if (land.ownership == "1") {
                            ownership = "Owner";
                        } else if (land.ownership == "2") {
                            ownership = "Tenant";
                        } else if (land.ownership == "3") {
                            ownership = "Lease";
                        }
                        return {
                            f_plot_no: land.f_plot_no || '',
                            plot_no: land.plot_no || '',
                            holding_no: land.holding_no || '',
                            holding_area: land.holding_area || '',
                            holding_type_id: type,
                            mouza_no: land.mouza_no || '',
                            jl_no: land.jl_no || '',
                            khatiyan: land.khatiyan || '',
                            ownership: ownership,
                            latitude: land.latitude || '',
                            longitude: land.longitude || ''
                        }
                    });
                    setLandDetals(landDetail);
                }
            })
            .catch(error => {
                console.error('Error fetching land details:', error);
                // let notify = notification({
                //     message: "Failed to fetch land details",
                //     type: 'error',
                // });
                // notify();
            });
    };

    const get_document_dtl = () => {
        let postData = [{ "org_id": Number(sessionStorage.getItem('org_id')), "user_id": Number(sessionStorage.getItem('user_id')), "farmer_code": Number(data.farmer_code) }];
        axios({
            method: 'post',
            url: mainurl + 'Farmer/farmer_document_view',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                if (!response.data || response.data.length === 0) {

                } else {
                    setDocumentDetals(response.data);
                }
            })
            .catch(error => {
                console.error('Error fetching document details:', error);

            });
    };

    return (
        <div id="farmer-details-container" className="p-3" style={{ backgroundColor: '#fff', }}>
            {/* Header Section */}
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h4 className="text-primary mb-1 fw-bold">
                        <FaUser className="me-2" />
                        Farmer Profile
                    </h4>
                    <p className="text-muted mb-0">Complete farmer information and records</p>
                </div>
                <Badge color="success" className="px-3 py-2 fs-6">
                    ID: {data.farmer_code}
                </Badge>
            </div>

            {/* Farmer Details Card */}
            <Card className="mb-4 shadow-sm border-0">
                <CardHeader className="bg-gradient bg-primary text-white border-0">
                    <div className="d-flex align-items-center">
                        <FaUser className="me-2" />
                        <h5 className="mb-0">Personal Information</h5>
                    </div>
                </CardHeader>
                <CardBody className="p-4">
                    <Row>
                        <Col md={2} className="text-center mb-3 mb-md-0">
                            <div className="position-relative d-inline-block">
                                <Avtar path="" />
                                <Badge
                                    color={gender === 'Male' ? 'info' : 'pink'}
                                    className="position-absolute top-0 end-0 rounded-circle"
                                    style={{ transform: 'translate(25%, -25%)' }}
                                >
                                    {gender === 'Male' ? '♂' : '♀'}
                                </Badge>
                            </div>
                        </Col>
                        <Col md={10}>
                            <Row>
                                <InfoCard
                                    icon={<FaUser />}
                                    label="Full Name"
                                    value={data.f_name}
                                    color="primary"
                                />
                                <InfoCard
                                    label="Name (Hindi)"
                                    value={data.f_name_ne}
                                    color="secondary"
                                />
                                <InfoCard
                                    label="Spouse Name"
                                    value={data.f_spouse_name}
                                    color="info"
                                />
                                <InfoCard
                                    label="Age"
                                    value={`${data.age} years`}
                                    color="warning"
                                />
                                <InfoCard
                                    label="Category"
                                    value={category}
                                    color="success"
                                />
                                <InfoCard
                                    label="Gender"
                                    value={gender}
                                    color={gender === 'Male' ? 'info' : 'pink'}
                                />
                                <InfoCard
                                    icon={<FaPhone />}
                                    label="Mobile Numbers"
                                    value={`${data.mobile_no} / ${data.mobile_no_2}`}
                                    color="dark"
                                />
                                <InfoCard
                                    icon={<FaMapMarkerAlt />}
                                    label="State"
                                    value={data.state_name}
                                    color="primary"
                                />
                                <InfoCard
                                    label="District"
                                    value={data.district_name}
                                    color="primary"
                                />
                                <InfoCard
                                    label="Block"
                                    value={data.block_name}
                                    color="primary"
                                />
                                <InfoCard
                                    label="Village"
                                    value={data.village_name}
                                    color="primary"
                                />
                            </Row>
                        </Col>
                    </Row>
                </CardBody>
            </Card>

            <Row>
                {/* Loan Details */}
                <Col lg={12} className='mb-4'>
                    <Card className='shadow-sm border-0 h-100'>
                        <CardHeader className="bg-gradient bg-success text-white border-0">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                    <FaUniversity className="me-2" />
                                    <h5 className="mb-0">Loan Portfolio</h5>
                                </div>
                                <Badge color="light" className="text-success">
                                    {loanData.length} Active Loans
                                </Badge>
                            </div>
                        </CardHeader>
                        <CardBody className="p-0">
                            <DataTable
                                customStyles={enhancedTableStyles}
                                columns={[
                                    {
                                        name: 'Bank Name',
                                        selector: row => row.bank,
                                        sortable: false,
                                        wrap: true,
                                    },
                                    {
                                        name: 'Account No.',
                                        selector: row => row.loan_ac_no,
                                        sortable: false,
                                        wrap: true,
                                    },
                                    {
                                        name: 'Type',
                                        selector: row => row.loan_type,
                                        sortable: false,
                                        wrap: true,
                                    },
                                    {
                                        name: 'Amount',
                                        selector: row => row.loan_amount,
                                        sortable: false,
                                        wrap: true,
                                    },
                                    {
                                        name: 'Disbursement Date',
                                        selector: row => row.loan_disbursement_date,
                                        sortable: false,
                                        wrap: true,
                                    },
                                    {
                                        name: 'Total Payment',
                                        selector: row => row.loan_payment_amount,
                                        sortable: false,
                                        wrap: true,
                                        width: '200px',
                                    },
                                    {
                                        name: 'Outstanding',
                                        selector: row => row.loan_outstanding,
                                        sortable: false,
                                        wrap: true,
                                    },
                                    {
                                        name: 'Status',
                                        selector: row => row.loan_status,
                                        sortable: false,
                                        wrap: true,
                                    }
                                ]}
                                data={loanData}
                                highlightOnHover
                                progressPending={loading}
                                noDataComponent={
                                    <div className="text-center py-5">
                                        <FaUniversity size={48} className="text-muted mb-3" />
                                        <p className="text-muted">No loan records found</p>
                                    </div>
                                }
                            />
                        </CardBody>
                    </Card>
                </Col>

                {/* Crop Pattern */}
                <Col lg={12} className='mb-4'>
                    <Card className='shadow-sm border-0 h-100'>
                        <CardHeader className="bg-gradient bg-warning text-white border-0">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                    <FaSeedling className="me-2" />
                                    <h5 className="mb-0">Cropping Pattern</h5>
                                </div>
                                <Badge color="light" className="text-warning">
                                    {cropPatternData.length} Crop Records
                                </Badge>
                            </div>
                        </CardHeader>
                        <CardBody className="p-0">
                            <DataTable
                                customStyles={enhancedTableStyles}
                                columns={[
                                    {
                                        name: 'Financial Year',
                                        selector: row => row.fy,
                                        sortable: false,
                                        wrap: true,
                                    },
                                    {
                                        name: 'Season',
                                        selector: row => <Badge color="primary" pill>{row.season}</Badge>,
                                        sortable: false,
                                        wrap: true,
                                    },
                                    {
                                        name: 'Crop Name',
                                        selector: row => <span className="fw-semibold">{row.crop_name}</span>,
                                        sortable: false,
                                        wrap: true,
                                    },
                                    {
                                        name: 'Area (Acre)',
                                        selector: row => <span className="fw-bold text-info">{row.area}</span>,
                                        sortable: false,
                                        wrap: true,
                                    },
                                    {
                                        name: 'Harvesting (Kg)',
                                        selector: row => <span className="fw-bold text-success">{row.harvesting}</span>,
                                        sortable: false,
                                        wrap: true,
                                    },
                                ]}
                                data={cropPatternData}
                                highlightOnHover
                                progressPending={loading}
                                noDataComponent={
                                    <div className="text-center py-5">
                                        <FaSeedling size={48} className="text-muted mb-3" />
                                        <p className="text-muted">No crop pattern records found</p>
                                    </div>
                                }
                            />
                        </CardBody>
                    </Card>
                </Col>

                {/* Land Details Row */}
                <Col lg={12} className='mb-4'>
                    <Card className='shadow-sm border-0'>
                        <CardHeader className="bg-gradient bg-dark text-white border-0">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                    <LuLandPlot className="me-2" />
                                    <h5 className="mb-0">Land Holdings</h5>
                                </div>
                                <Badge color="light" className="text-dark">
                                    Total: - acres
                                </Badge>
                            </div>
                        </CardHeader>
                        <CardBody className="p-4">
                            <DataTable
                                customStyles={enhancedTableStyles}
                                columns={[
                                    {
                                        name: 'Plot No.',
                                        selector: row => row.plot_no,
                                        sortable: false,
                                        wrap: true,
                                    },
                                    {
                                        name: 'Holding No.',
                                        selector: row => row.holding_no,
                                        sortable: false,
                                        wrap: true,
                                    },
                                    {
                                        name: 'Area',
                                        selector: row => row.holding_area,
                                        sortable: false,
                                        wrap: true,
                                    },
                                    {
                                        name: 'Holding Type',
                                        selector: row => row.holding_type_id,
                                        sortable: false,
                                        wrap: true,
                                    },
                                    {
                                        name: 'Mouza No.',
                                        selector: row => row.mouza_no,
                                        sortable: false,
                                        wrap: true,
                                    },
                                    {
                                        name: 'JL No.',
                                        selector: row => row.jl_no,
                                        sortable: false,
                                        wrap: true,
                                    },
                                    {
                                        name: 'Khatiyan',
                                        selector: row => row.khatiyan,
                                        sortable: false,
                                        wrap: true,
                                    },
                                    {
                                        name: 'Ownership',
                                        selector: row => row.ownership,
                                        sortable: false,
                                        wrap: true,
                                    },
                                    {
                                        name: 'Latitude',
                                        selector: row => row.latitude,
                                        sortable: false,
                                        wrap: true,
                                    },
                                    {
                                        name: 'Longitude',
                                        selector: row => row.longitude,
                                        sortable: false,
                                        wrap: true,
                                    },
                                ]}
                                data={landDetals}
                                highlightOnHover
                                progressPending={loading}
                            />
                        </CardBody>
                    </Card>
                </Col>

                {/* Bank Details Row */}
                <Col lg={12} className='mb-4'>
                    <Card className='shadow-sm border-0'>
                        <CardHeader className="bg-gradient bg-dark text-white border-0">
                            <div className="d-flex align-items-center justify-content-start">
                                <div className="d-flex align-items-center">
                                    <BsBank2 className="me-2" />
                                    <h5 className="mb-0">Bank Details</h5>
                                </div>
                            </div>
                        </CardHeader>
                        <CardBody className="p-4">
                            <DataTable
                                customStyles={enhancedTableStyles}
                                columns={[
                                    {
                                        name: 'Bank Name',
                                        selector: row => row.bank_id,
                                        sortable: false,
                                        wrap: true,
                                    },
                                    {
                                        name: 'IFSC code',
                                        selector: row => row.ifsc_code,
                                        sortable: false,
                                        wrap: true,
                                    },
                                    {
                                        name: 'Account No.',
                                        selector: row => row.ac_no,
                                        sortable: false,
                                        wrap: true,
                                    },
                                    {
                                        name: 'Account Type',
                                        selector: row => row.ac_type,
                                        sortable: false,
                                        wrap: true,
                                    },
                                    {
                                        name: 'Branch Name',
                                        selector: row => row.branch_name,
                                        sortable: false,
                                        wrap: true,
                                    },
                                    {
                                        name: 'Balance',
                                        selector: row => row.balance,
                                        sortable: false,
                                        wrap: true,
                                    },
                                    {
                                        name: 'Balance Type',
                                        selector: row => row.balance_type,
                                        sortable: false,
                                        wrap: true,
                                    },
                                ]}
                                data={bankDetals}
                                highlightOnHover
                                progressPending={loading}
                            />
                        </CardBody>
                    </Card>
                </Col>

                {/* Irrigation & Land Details Row */}
                <Col lg={6} className="mb-4">
                    <Card className='shadow-sm border-0 h-100'>
                        <CardHeader className="bg-gradient bg-info text-white border-0">
                            <div className="d-flex align-items-center">
                                <FaTint className="me-2" />
                                <h5 className="mb-0">Source of Irrigation</h5>
                            </div>
                        </CardHeader>
                        <CardBody className="p-4">
                            <Row>
                                <IrrigationCard
                                    src={require('../../../assets/img/well.png')}
                                    title="Well"
                                    //isActive={true}
                                />
                                <IrrigationCard
                                    src={require('../../../assets/img/pond.png')}
                                    title="Pond"
                                />
                                <IrrigationCard
                                    src={require('../../../assets/img/canel.png')}
                                    title="Canal"
                                />
                                <IrrigationCard
                                    src={require('../../../assets/img/rain.png')}
                                    title="Rainfed"
                                />
                                <IrrigationCard
                                    src={require('../../../assets/img/drip.png')}
                                    title="Drip"
                                />
                            </Row>
                        </CardBody>
                    </Card>
                </Col>

                <Col lg={6} className="mb-4">
                    <Card className='shadow-sm border-0 h-100'>
                        <CardHeader className="bg-gradient bg-dark text-white border-0">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                    <FaIdCardAlt className="me-2" />
                                    <h5 className="mb-0">Documents</h5>
                                </div>
                            </div>
                        </CardHeader>
                        <CardBody className="p-4">
                            <Row>
                                {
                                    documentDetals && documentDetals.length > 0 ?
                                        documentDetals.map(row => {
                                            return (
                                                <InfoCard
                                                    label={row.doc_name}
                                                    value={row.doc_no}
                                                    color={row.doc_type_id == 1 ? "primary" : row.doc_type_id == 2 ? "info" : row.doc_type_id == 3 ? "warning" : row.doc_type_id == 4 ? "success" : "primary"  }
                                                />
                                            )
                                        }) : "No documents available"
                                }
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            {/* Action Buttons */}
            <div className='d-flex justify-content-end gap-3 mt-4 action-buttons'>
                <Button
                    color='success'
                    size="lg"
                    onClick={exportToPDF}
                    disabled={pdfGenerating}
                    className="px-4 rounded-pill shadow-sm"
                >
                    {pdfGenerating ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Generating PDF...
                        </>
                    ) : (
                        <>
                            <BiDownload className='me-2' size={18} />
                            Export PDF
                        </>
                    )}
                </Button>

                <Button
                    color='primary'
                    size="lg"
                    onClick={back}
                    className="px-4 rounded-pill shadow-sm"
                >
                    ← Back to List
                </Button>
            </div>

            {/* Modal for Loan Details */}
            <Modal
                centered
                scrollable
                size="lg"
                isOpen={viewModal}
                toggle={() => setViewModal(!viewModal)}
                className="modal-modern"
            >
                <ModalHeader
                    toggle={() => setViewModal(!viewModal)}
                    className="bg-gradient bg-primary text-white border-0"
                >
                    <div className="d-flex align-items-center">
                        <FaUniversity className="me-2" />
                        Loan Payment Details
                    </div>
                </ModalHeader>
                <ModalBody className="p-0">
                    <DataTable
                        customStyles={enhancedTableStyles}
                        columns={[
                            {
                                name: '#',
                                selector: row => row.ids,
                                sortable: true,
                                width: '80px',
                            },
                            {
                                name: 'Payment Date',
                                selector: row => row.pay_date,
                                sortable: false,
                                wrap: true,
                            },
                            {
                                name: 'Payment Amount',
                                selector: row => row.pay_amount,
                                sortable: false,
                                wrap: true,
                            },
                            {
                                name: 'Reference No.',
                                selector: row => row.ref_no,
                                sortable: false,
                                wrap: true,
                            },
                        ]}
                        data={loanDetailData}
                        highlightOnHover
                        progressPending={loading}
                        pagination
                        paginationPerPage={10}
                        paginationRowsPerPageOptions={[5, 10, 15]}
                    />
                </ModalBody>
            </Modal>

            <style jsx>{`
                .hover-shadow:hover {
                    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
                    transform: translateY(-2px);
                    transition: all 0.3s ease;
                }
                
                .bg-light-success {
                    background-color: rgba(40, 167, 69, 0.1);
                }
                
                .transition-all {
                    transition: all 0.3s ease;
                }
                
                .modal-modern .modal-content {
                    border: none;
                    border-radius: 12px;
                    overflow: hidden;
                }
                
                .bg-gradient {
                    background: linear-gradient(135deg, var(--bs-primary) 0%, rgba(var(--bs-primary-rgb), 0.8) 100%);
                }
                
                .bg-gradient.bg-success {
                    background: linear-gradient(135deg, var(--bs-success) 0%, rgba(var(--bs-success-rgb), 0.8) 100%);
                }
                
                .bg-gradient.bg-warning {
                    background: linear-gradient(135deg, var(--bs-warning) 0%, rgba(var(--bs-warning-rgb), 0.8) 100%);
                }
                
                .bg-gradient.bg-info {
                    background: linear-gradient(135deg, var(--bs-info) 0%, rgba(var(--bs-info-rgb), 0.8) 100%);
                }
                
                .bg-gradient.bg-dark {
                    background: linear-gradient(135deg, var(--bs-dark) 0%, rgba(var(--bs-dark-rgb), 0.8) 100%);
                }
            `}</style>
        </div>
    )
}

export default ViewFarmer;